const { Appcues } = window;

class InAppHelpWrapper {
  init = (userId = '', lastLogin = '', role = '', customProps) => {
    if (Appcues) {
      Appcues.identify(userId, {
        role,
        lastLogin,
        ...customProps,
      });
      Appcues.loadLaunchpad('#app-cues-widget-quick-tips', {
        header: '<h1>Announcements</h1>',
        position: 'left',
        // We need to have an empty icon so we can replace
        // the icon provided by appcues.
        icon: ' ',
      });
    }
  };

  refresh = () => {
    Appcues && Appcues.page();
  };
}

export default InAppHelpWrapper;
